module.exports = __webpack_public_path__ + "img/banner_one.acd6c6e9.png";